import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Skeleton } from "primereact/skeleton";
import React from "react";

const GlobalDataTableSkeleton = ({
  totalColumns = 1,
  parentClassName = "",
}) => {
  const skeletonData = Array.from({ length: 10 }, () => ({}));

  return (
    <Card className={`${parentClassName} mt-6`}>
      <DataTable
        value={skeletonData}
        showGridlines
        paginator
        rows={10}
        rowHover={true}
        rowsPerPageOptions={[10, 20, 50]}
        emptyMessage=""
      >
        {Array.from({ length: totalColumns }, (_, index) => (
          <Column
            key={index}
            field={`col${index}`}
            header={<Skeleton width="100%" height="1.5rem" />}
            headerClassName="bg-primary-primaryDarkGray text-primary-primaryYellow"
            body={() => <Skeleton width="100%" height="1.5rem" />}
          />
        ))}
      </DataTable>
    </Card>
  );
};

export default GlobalDataTableSkeleton;
